@if (brandOrgsFilterConfig; as config) {
<epc-dashboard-filter-select
  [filterValues]="config.values"
  [selectedValues]="config.selected"
  [defaultText]="config.defaultText"
  [showAllText]="config.showAllText"
  [isSingle]="config.isSingle"
  (filterChanged)="filterChanged({ brandOrgIds: $event }, config)"
  class="mr-3"
>
</epc-dashboard-filter-select>
} @if (dateFilterConfig; as config) {
<div class="filters-sort__date mr-3">
  <button
    #dateFilterSelection="atxPopover"
    atxDropdown
    atxPlacement="bottomRight"
    class="btn btn-light d-flex align-items-center justify-content-between"
    [atxDropdownMenu]="menu"
    [atxPopover]="customSelectionDateRange"
    [popoverPlacement]="placement.BOTTOM_LEFT"
    autoClose="outside"
    triggers="manual"
  >
    <span class="font-size-sm text-truncate">{{
      selectedDateOptionLabel$ | async
    }}</span>
    <fa-icon class="font-size-sm ml-2" [icon]="['fas', 'angle-down']"></fa-icon>
  </button>
  <atx-dropdown-menu
    [extraClasses]="['dashboard-dropdown']"
    #menu="atxDropdownMenu"
  >
    @for (option of dateFilterOptions; track option; let isEven = $even) {
    <atx-dropdown-item [class.my-2]="isEven" (click)="filterByDate(option)">
      <span class="font-size-base text-muted">{{ option.label }}</span>
    </atx-dropdown-item>
    }
    <atx-dropdown-item>
      <span
        class="font-size-base text-muted"
        (click)="dateFilterSelection.open()"
        i18n="AnalyticsDashboard|Choose specific dates@@chooseSpecificDates"
        >Choose specific dates</span
      >
    </atx-dropdown-item>
  </atx-dropdown-menu>
  <ng-template #customSelectionDateRange>
    <atx-date-range-picker
      class="p-2"
      [displayFooterHandlers]="true"
      [displayMonths]="1"
      [useResetText]="true"
      [minDate]="config.minDate"
      [maxDate]="config.maxDate"
      [useUTCDayTimeConversion]="true"
      (rangeSelect)="
        customDateRangeSelected($event); dateFilterSelection.close()
      "
    >
    </atx-date-range-picker>
  </ng-template>
</div>
} @if (orderTypeFilterConfig; as config) {
<epc-dashboard-filter-select
  [filterValues]="config.values"
  [selectedValues]="config.selected"
  [defaultText]="config.defaultText"
  [isSingle]="true"
  [showValueAsLabelText]="true"
  (filterChanged)="filterChanged({ orderType: $event }, config)"
  class="mr-3"
>
</epc-dashboard-filter-select>
} @if (categoriesFilterConfig; as config) {
<epc-dashboard-filter-select
  [filterValues]="config.values"
  [selectedValues]="config.selected"
  [defaultText]="config.defaultText"
  [isSingle]="config.isSingle"
  (filterChanged)="filterChanged({ categories: $event }, config)"
  class="mr-3"
>
</epc-dashboard-filter-select>
}
